import { SVGProps, Ref, forwardRef } from 'react';

export const StackoverflowSolidSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path d="m16.485 16.618-9.6-2.018.403-1.92 9.6 2.019z" fill="currentColor" />
        <path d="m17.048 14.145-8.893-4.141.828-1.779 8.894 4.142z" fill="currentColor" />
        <path d="m18.155 11.919-7.54-6.278 1.256-1.508 7.54 6.278z" fill="currentColor" />
        <path d="M13.908 2.171 15.483 1l5.854 7.872-1.574 1.17z" fill="currentColor" />
        <path d="M16.483 19.09H6.709v-1.954h9.774z" fill="currentColor" />
        <path d="M20.392 15.181h-1.955v5.864H4.755v-5.864H2.8V23h17.592z" fill="currentColor" />
    </svg>
));
StackoverflowSolidSize24Glyph.displayName = 'StackoverflowSolidSize24Glyph';
